/**
 * Custom cursor for the annotate tool, drawn to match its paint roller icon.
 *
 * White fill with a dark outline so it reads on light and dark models. Falls
 * back to the pointer hand if a browser can't show the image.
 */

const outline = "#262626";

const paintRollerSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="white" stroke="${outline}" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round">
<rect x="3.5" y="3.5" width="14" height="5.5" rx="1.5"/>
<path fill="none" d="M17.5 6.25H19a1.5 1.5 0 0 1 1.5 1.5v2.5a1.5 1.5 0 0 1-1.5 1.5h-7a1.5 1.5 0 0 0-1.5 1.5v1.25"/>
<rect x="9" y="14.5" width="3" height="6" rx="1"/>
</svg>`;

function toCursor(svg: string, hotspotX: number, hotspotY: number) {
  return `url("data:image/svg+xml,${encodeURIComponent(svg)}") ${hotspotX} ${hotspotY}, pointer`;
}

/** The click lands at the top edge of the roller head. */
export const paintRollerCursor = toCursor(paintRollerSvg, 10, 4);
